import Vue from 'vue'

export const JobsPage = Vue.component('jobs-page', require('./JobsPage.vue'));
export const JobShowPage = Vue.component('jobs-show-page', require('./JobShowPage.vue'));
export const JobCard = Vue.component('job-card', require('./JobCard.vue'));
export const FilterBar = Vue.component('jobs-filter-bar',require('./FilterBar'));



// WEBPACK FOOTER //
// ./resources/assets/js/views/jobs/index.js